<template>
  <section class="content-section">
    <div class="container">
      <h2>
        <contentful-text
          :item="contentfulText('homepage-2023-v01-grad-stats-title')"
          :render-inline="true"
        />
      </h2>
      <div class="row justify-content-center align-items-center g-0">
        <div class="col-10 offset-1 col-md-8 offset-md-1 offset-lg-3 col-xl-4 offset-xl-0 grad-stats__column">
          <grad-stat
            :statistic="contentfulText('homepage-2023-v01-grad-stat-1-stat').Content"
            :label="contentfulText('homepage-2023-v01-grad-stat-1-label').Content"
            :image-content-item="contentfulImage('homepage-2023-v01-grad-stat-1-image')"
            display-mode="long"
          />
        </div>
        <div class="col-10 offset-1 col-md-8 offset-md-1 offset-lg-3 col-xl-4 offset-xl-0 grad-stats__column">
          <grad-stat
            :statistic="contentfulText('homepage-2023-v01-grad-stat-2-stat').Content"
            :label="contentfulText('homepage-2023-v01-grad-stat-2-label').Content"
            :image-content-item="contentfulImage('homepage-2023-v01-grad-stat-2-image')"
            display-mode="short"
          />
        </div>
        <div class="col-10 offset-1 col-md-8 offset-md-1 offset-lg-3 col-xl-4 offset-xl-0 grad-stats__column">
          <grad-stat
            :statistic="contentfulText('homepage-2023-v01-grad-stat-3-stat').Content"
            :label="contentfulText('homepage-2023-v01-grad-stat-3-label').Content"
            :image-content-item="contentfulImage('homepage-2023-v01-grad-stat-3-image')"
            display-mode="short"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import GradStat from '../ContentItems/GradStat.vue'

export default {
  name: 'GradStats',
  components: {
    GradStat
  },
  computed: {
    content () {
      return this.$store.state.pageContent
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/bootstrap-grid";

.content-section {
  background-color: #4c7499;
  padding: 3rem 0;

  @media screen and (min-width: $screen-sm-min) {
    padding: 4rem 0;
  }
}

h2 {
  color: #fff;
  font-family: $font-barlow-condensed;
  font-size: 1.625rem;
  font-weight: 600;
  line-height: 1.875rem;
  text-transform: uppercase;
  margin-bottom: 2rem;
  text-align: center;

  @media screen and (min-width: $screen-sm-min) {
    font-size: 3.375rem;
    line-height: 3.375rem;
  }
}

.grad-stats {
  &__column {
    border: none;
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/grad-images/home/index/components/ContentSections/GradStats.vue